var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBasketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#1f1f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250-177q-19 0-34.75-11t-20.75-30l-83-291.5q-4-13.56 4.75-24.78t23.25-11.22h186l131.43-199.91q4.84-6.65 10.76-9.62Q473.6-758 481.5-758q7.11 0 13.05 3.5 5.95 3.5 10.31 9.82L634.5-545.5h186.73q13.62 0 22.95 11.25Q853.5-523 849-509.5L763.5-218q-5 19-20.75 30T708-177H250Zm-3.85-25.5H714q11 0 19-6.5t11-17.5L825.5-520h-691l81.65 293.5q3 11 11 17.5t19 6.5Zm251.6-141.27q7.75-7.77 7.75-17.75t-7.77-17.73q-7.77-7.75-17.75-7.75t-17.73 7.77q-7.75 7.77-7.75 17.75t7.77 17.73q7.77 7.75 17.75 7.75t17.73-7.77ZM357-545.5h246.5L480.5-735 357-545.5Zm123 184Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBasketIcon);
export default __webpack_public_path__ + "static/media/ShoppingBasketIcon.cb992e4ba670c729bce39d49a15b5232.svg";
export { ForwardRef as ReactComponent };